import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const RISK_DIRECTORIES_TABLE_STATE_STORAGE_KEY =
    "userRiskDirectoriesList";

export const RISK_DIRECTORIES_LIST_COLUMN_IDS = {
    TITLE: "title",
    DESCRIPTION: "description",
    ACCESS_RIGHT: "accessRight",
} as const;

export const riskDirectoriesListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: RISK_DIRECTORIES_LIST_COLUMN_IDS.TITLE, desc: false }],
    };

export const riskDirectoriesListColumnFiltersCodecMap = {
    [RISK_DIRECTORIES_LIST_COLUMN_IDS.TITLE]: withModeCodec(encodedArrayCodec),
    [RISK_DIRECTORIES_LIST_COLUMN_IDS.ACCESS_RIGHT]:
        withModeCodec(encodedArrayCodec),
};
